
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h88.54v88.54H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M.31 49.4a44.25 44.25 0 0073.31 28l2.12-2A44.27 44.27 0 100 44.27c0 1.06.05 2.1.12 3.13z","fill":"#ee7203"}})]),_c('path',{attrs:{"fill":"#fff","d":"M29.93 16.73h27.38v53.62H29.93z"}}),_c('path',{attrs:{"fill":"#ee7203","d":"M46.64 21.48L32.98 46.8h14.4L41.8 67.06l13.35-24.62H40.83l5.81-20.96z"}}),_c('path',{attrs:{"d":"M81.75 59.54H80v-2.43h1.78a.69.69 0 00.7-.68.69.69 0 00-.7-.69H80v-1h-5.86A4 4 0 0070.59 57H57.12v2.34h13.47a4 4 0 003.55 2.24H80v-.67h1.78a.69.69 0 00.7-.68.69.69 0 00-.7-.69","fill":"#fff"}})])
          )
        }
      }
    